'use client';

import React from 'react';
import styles from './SettingTab.module.scss';

interface ArrowHeadProps {
  direction: 'bot' | 'top';
}

/**
 * ArrowHead component for left/right arrows in settings bar
 * Uses Top_ArrowHead.svg for right direction and Bottom_ArrowHead.svg for left direction
 */
const ArrowHead: React.FC<ArrowHeadProps> = ({ direction }) => {
  return (
    <div className={styles.arrowHead}>
      <div className={styles.arrowIcon}>
        {direction === 'bot' ? (
          <img 
            src="/images/Bottom_ArrowHead.svg" 
            alt="" 
            width="70" 
            height="70"
          />
        ) : (
          <img 
            src="/images/Top_ArrowHead.svg" 
            alt="" 
            width="70" 
            height="70"
          />
        )}
      </div>
    </div>
  );
};

export default ArrowHead;
